
import { useStore } from '@/store'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'GeneralPopupContent',
  setup () {
    const { popupData } = useStore()
    const html = computed(() => {
      if (popupData.value.contentData.type === 'general') {
        return popupData.value.contentData.html
      }
      throw new Error('Invalid popup content data for "GeneralPopupContent" component.')
    })

    return {
      html
    }
  }
})
